// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "header[data-v-929c3b4c]{background:#baeb49;display:flex;flex-direction:row;justify-content:space-between;align-items:center;margin-bottom:3em;padding:2em 1em;border-bottom:1px solid var(--grey__light)}header img[data-v-929c3b4c]{height:2em}header a[data-v-929c3b4c],header span[data-v-929c3b4c]{margin:0 .5em;font-size:18px;color:inherit;text-decoration:none;color:#fff;cursor:pointer}", ""]);
// Exports
module.exports = exports;
